<template>
<div class="chapter">
<div class="inner_page">
<a id="page_4"></a>
<h2 class="fm_title" id="gloss"><span class="bold">GLOSSARY</span></h2>
<table class="table">
<tbody><tr>
<td class="td1"><span href="#/xhtml/06_Chapter01#gloss_1" id="rgloss_1" title="Link target outside of Sample">CCP</span></td>
<td class="td2">Chinese Communist Party</td>
</tr>
<tr>
<td class="td1"><a href="#/xhtml/05_Introduction#gloss_2" id="rgloss_2">CIA</a></td>
<td class="td2">Central Intelligence Agency (US)</td>
</tr>
<tr>
<td class="td1"><a href="#/xhtml/05_Introduction#gloss_3" id="rgloss_3">CPVA</a></td>
<td class="td2">Chinese People’s Volunteer Army</td>
</tr>
<tr>
<td class="td1" id="gloss_4">DPRK</td>
<td class="td2">Democratic People’s Republic of Korea (North Korea)</td>
</tr>
<tr>
<td class="td1" id="rgloss_5">EUSAK</td>
<td class="td2">Eighth United States Army in Korea</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/07_Chapter02#gloss_6" id="rgloss_6" title="Link target outside of Sample">FAB</span></td>
<td class="td2">field artillery battalion</td>
</tr>
<tr>
<td class="td1"><a href="#/xhtml/05_Introduction#gloss_7" id="rgloss_7">FEAF</a></td>
<td class="td2">Far East Air Forces (US)</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/08_Chapter03#gloss_8" id="rgloss_8" title="Link target outside of Sample">GIAP</span></td>
<td class="td2">Guards Interceptor Air Regiment (Soviet)</td>
</tr>
<tr>
<td class="td1" id="rgloss_9">HE</td>
<td class="td2">high explosive</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/08_Chapter03#gloss_10" id="rgloss_10" title="Link target outside of Sample">IAD</span></td>
<td class="td2">Interceptor–fighter Air Division (Soviet)</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/08_Chapter03#gloss_11" id="rgloss_11" title="Link target outside of Sample">IAK</span></td>
<td class="td2">Fighter Air Corps (Soviet)</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/08_Chapter03#gloss_12" id="rgloss_12" title="Link target outside of Sample">IAP</span></td>
<td class="td2">Interceptor–fighter Air Regiment</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/08_Chapter03#gloss_13" id="rgloss_13" title="Link target outside of Sample">JOC</span></td>
<td class="td2">Joint Operations Centre</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/08_Chapter03#gloss_14" id="rgloss_14" title="Link target outside of Sample">JCS</span></td>
<td class="td2">Joint Chiefs of Staff (US)</td>
</tr>
<tr>
<td class="td1" id="rgloss_15">KATUSA</td>
<td class="td2">Korean Augmentation to the US Army</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/07_Chapter02#gloss_16" id="rgloss_16" title="Link target outside of Sample">KMAG</span></td>
<td class="td2">Korea Military Advisory Group (US)</td>
</tr>
<tr>
<td class="td1"><a href="#/xhtml/05_Introduction#gloss_17" id="rgloss_17">KPA</a></td>
<td class="td2">Korean People’s Army (North Korean)</td>
</tr>
<tr>
<td class="td1" id="rgloss_18">MLR</td>
<td class="td2">main line of resistance</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/10_Chapter05#gloss_19" id="rgloss_19" title="Link target outside of Sample">MSR</span></td>
<td class="td2">main supply route</td>
</tr>
<tr>
<td class="td1"><a href="#/xhtml/05_Introduction#gloss_20" id="rgloss_20">PLA</a></td>
<td class="td2">People’s Liberation Army (China)</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/08_Chapter03#gloss_21" id="rgloss_21" title="Link target outside of Sample">PLAAF</span></td>
<td class="td2">People’s Liberation Army Air Force (China)</td>
</tr>
<tr>
<td class="td1"><a href="#/xhtml/05_Introduction#gloss_22" id="rgloss_22">PRC</a></td>
<td class="td2">People’s Republic of China</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/09_Chapter04#gloss_23" id="rgloss_23" title="Link target outside of Sample">RCT</span></td>
<td class="td2">Regimental Combat Team</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/07_Chapter02#gloss_24" id="rgloss_24" title="Link target outside of Sample">ROK</span></td>
<td class="td2">Republic of Korea (South Korea)</td>
</tr>
<tr>
<td class="td1"><a href="#/xhtml/05_Introduction#gloss_25" id="rgloss_25">ROKA</a></td>
<td class="td2">Republic of Korea Army (South Korean)</td>
</tr>
<tr>
<td class="td1" id="rgloss_26">TF</td>
<td class="td2">task force</td>
</tr>
<tr>
<td class="td1" id="rgloss_27">UNC</td>
<td class="td2">United Nations Command</td>
</tr>
<tr>
<td class="td1"><span href="#/xhtml/06_Chapter01#gloss_28" id="rgloss_28" title="Link target outside of Sample">USMC</span></td>
<td class="td2">United States Marine Corps</td>
</tr>
</tbody></table>
<p class="noindent">It will be noticed that many Korean names of places and geographical features either carry the same suffix or end in the same few letters. These define what a name is being applied to, e.g. Ch’ŏng<em class="italic">ch’ŏn</em> would be Ch’ŏng River: <em class="italic">ch’ŏn</em> or <em class="italic">gang</em> river; <em class="italic">do</em> island; <em class="italic">dong</em> town or village within a district or <em class="italic">ri</em>; <em class="italic">ni</em> town; <em class="italic">ri</em> town and surrounding district; <em class="italic">san</em> mountain.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Glossary.vue?776bd4a6